module.exports = __webpack_public_path__ + "static/media/ic-actions-calendar.1a3c0be6.svg";